import { useEffect } from "react";
//#region src/hooks/useOnClickOutside.ts
function useOnClickOutside(ref, handler) {
	useEffect(() => {
		if (!handler) return;
		const listener = (event) => {
			if (!ref.current || ref.current?.contains(event.target)) return;
			handler(event);
		};
		document?.addEventListener("mousedown", listener);
		document?.addEventListener("touchstart", listener);
		return () => {
			document?.removeEventListener("mousedown", listener);
			document?.removeEventListener("touchstart", listener);
		};
	}, [ref, handler]);
}
//#endregion
export { useOnClickOutside };

//# sourceMappingURL=useOnClickOutside.js.map